import { render } from "./PerfilView.vue?vue&type=template&id=1c63301c&scoped=true&ts=true"
import script from "./PerfilView.vue?vue&type=script&lang=ts"
export * from "./PerfilView.vue?vue&type=script&lang=ts"

import "./PerfilView.vue?vue&type=style&index=0&id=1c63301c&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Ronnald\\Desktop\\page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c63301c"]])

export default __exports__